import React, { useEffect, useState } from 'react';
const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show the floating CTA after scrolling 40% of the page height
      const scrollThreshold = document.body.scrollHeight * 0.4;
      if (window.scrollY > scrollThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-50 md:bottom-10 md:right-10 transition-all duration-300 ease-in-out" data-id="element-96">
      <a href="https://veiramode.com/products/nie-zapomnij-o-sobie-ebook" target="_blank" rel="noopener noreferrer" className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-lg shadow-xl text-lg transition-all transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-300 animate-pulse hover:animate-none" data-id="element-97">
        ODZYSKAJ SIEBIE →
      </a>
    </div>;
};
export default FloatingCTA;